import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import "react-toastify/dist/ReactToastify.css";
import Button from "react-bootstrap/Button";
import RightModal from "./modalForm";

// hooks
import {useHistory, useRedux, useSearchInput} from "../../../hooks";

import {
    editDataPeerActivityType,
    getPeerActivityTypes,
    onRemovePeerActivityType,
    removePeerActivityTypeModalHide,
    removePeerActivityTypeModalShow,
    showRightModalPeerActivityType
} from "../../../redux/actions";

import TableList from "../../../components/TableList";
import PeerActivityTypeColumns from "./tableColumns";
import {PeerActivityTypeType} from "../../../redux/Content/PeerActivityType/types";
import {EntityActionsHandlersType} from "../../../redux/types";
import RemoveModal from "../../../components/RemoveForm";

import '../../../i18/config';
import {useTranslation} from "react-i18next";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import Loader from "../../../components/Loader";
import {HistoryHashType, PAGINATION_DEFAULT_ITEMS_PER_PAGE} from "../../../data/settings";
import MainListFilter from "../../../components/MainListFilter";

const PeerActivityTypeIndex = () => {
    const { dispatch, useAppSelector } = useRedux();

    const { t } = useTranslation(['common']);

    const componentType = 'peerActivityTypeTable';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getPeerActivityTypes,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const [perPage, setPerPage] = useState(PAGINATION_DEFAULT_ITEMS_PER_PAGE);

    const {
        peerActivityType,
        isFetched
    } = useAppSelector(state => ({
        peerActivityType: state.PeerActivityType,
        isFetched: state.PeerActivityType.isFetched
    }));

    useEffect(() => {
        if (peerActivityType.isNeedReload){
            loadItems();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, peerActivityType.isNeedReload]);

    const openRightModal = (event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(editDataPeerActivityType({data:event, modalEditTitle: 'changePeerActivityType'}));
        } else {
            dispatch(showRightModalPeerActivityType({data:[], modalEditTitle: 'newPeerActivityType'}));
        }
    };

    const onEntityRemoveModalShow = (event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(removePeerActivityTypeModalShow({data:event, modalEditTitle: 'deletePeerActivityType'}));
        }
    };

    const onEntityRemoveModalHide = () => dispatch(removePeerActivityTypeModalHide());

    const onEntityRemove = (event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(onRemovePeerActivityType({data:event, modalEditTitle: 'deletePeerActivityType'}));
        }
    };

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onEdit: openRightModal,
        onRemove: onEntityRemoveModalShow
    }

    const onTableRowClick = (item:PeerActivityTypeType) => {
        if (item.actions && item.actions.canEdit){
            openRightModal(item);
        }
    }

    const columns = PeerActivityTypeColumns(EntityActionsHandlers);

    return (
        <>
            <BreadCrumb title={t('menu:activitiesTypes')} pageTitle={t('menu:main')} />
                <Row className="g-4 mb-3">
                    <div className="col-sm-auto">
                        <div>
                            <Button variant="secondary" onClick={openRightModal} className="btn btn-success">
                                <i className="ri-add-line align-bottom me-1"/> {t('common:addNew')}
                            </Button>
                        </div>
                    </div>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="border-bottom-0">
                                <h5 className="card-title mb-0">{t('peerActivityType:activityType')}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                                <MainListFilter
                                    onClick={handleSearchClick}
                                    value={searchPhrase}
                                    onChange={onSearchInput}
                                />
                            </CardBody>
                            <CardBody>
                                {isFetched ?
                                    <TableList
                                    columns={columns}
                                    data={peerActivityType.items}
                                    onRowClick={onTableRowClick}
                                    key={componentType}
                                    historyHash = {historyHash}
                                    paginationTotalRows={peerActivityType?.meta?.totalCount || 0}
                                    paginationServer={true}
                                    />
                                    :
                                    <Loader/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <RightModal/>
                <RemoveModal
                    onRemove={onEntityRemove}
                    handleClose={onEntityRemoveModalHide}
                    removeItem={peerActivityType.selectedItem}
                    isOpen={peerActivityType.removeModalShow}
                    modalTitle={peerActivityType.modalEditTitle}/>
        </>
    );
};

export default PeerActivityTypeIndex;


